import React from "react";
import { Dropdown } from "react-bootstrap";
// import { DEV_CLARITY_URL, GOVERN_ITEMS, PROD_CLARITY_URL } from "../../constants/Constant";
import { Link } from 'react-router-dom'
const GovernDropdownContent = (props) => {
  // const governdata = GOVERN_ITEMS;

  // const CLARITY_URL =
  //   process.env.NODE_ENV === "development" &&
  //     process.env.REACT_APP_RUN_ENV === "development"
  //     ? DEV_CLARITY_URL
  //     : PROD_CLARITY_URL;

  return (
    <Dropdown>
      <Dropdown.Toggle id="dropdown-basic" className="btn-sm">
        <span>{props.dropdownData.title}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props.dropdownData.data &&
          props.dropdownData.data.map((gdata, idx) => {
            // if (gdata.menu === "Insights") {
            //   return (<Dropdown.Item key={idx}  >
            //     <div onClick={() => window.open(CLARITY_URL, "_blank")}>
            //       {gdata.menu}
            //     </div>

            //   </Dropdown.Item>)
            // } else {
            return (<Dropdown.Item key={idx} as={Link} to={gdata.url}>
              {gdata.menu}
            </Dropdown.Item>)
            // }

          })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default GovernDropdownContent;
